var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.5 17.625a.625.625 0 0 1-.626.625h-10a.625.625 0 0 1-.624-.625V6.375a.625.625 0 0 1 .625-.625h10a.625.625 0 0 1 .624.625v2.5a.625.625 0 1 0 1.25 0v-2.5A1.875 1.875 0 0 0 13.874 4.5h-10A1.875 1.875 0 0 0 2 6.375v11.25A1.875 1.875 0 0 0 3.875 19.5h10a1.875 1.875 0 0 0 1.874-1.875v-2.5a.625.625 0 1 0-1.25 0v2.5Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21.817 12.443a.625.625 0 0 0 0-.885l-3.75-3.75a.626.626 0 0 0-.885.885l2.684 2.682H8.875a.625.625 0 1 0 0 1.25h10.99l-2.683 2.683a.625.625 0 1 0 .885.885l3.75-3.75Z",
    clipRule: "evenodd"
  })));
};
export default SvgLogout;